import { render, staticRenderFns } from "./TheModalDescuentos.vue?vue&type=template&id=7dc71192&"
import script from "./TheModalDescuentos.vue?vue&type=script&lang=js&"
export * from "./TheModalDescuentos.vue?vue&type=script&lang=js&"
import style0 from "./TheModalDescuentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports